import { useEffect } from 'react';
import useCurrencies from '@/creditflowresearch/application/hooks/useCurrencies';

const useGetCurrencies = () => {
  const { collection, getCurrenciesList } = useCurrencies();

  useEffect(() => {
    if (collection.length) return;
    getCurrenciesList();
  }, []);

  return collection;
};

export default useGetCurrencies;
